module.exports = __webpack_public_path__ + "img/romania.3db12911.svg";